import React from "react";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react";

import { useStore } from "../../store";
import { IrregularList } from "../../components";
import { setSelectType } from "../../utils/storage";

const FeedsList = () => {
  const history = useHistory();
  const {
    appStore: {
      apiHeaderState,
      appState: { languageCode },
    },
    feedStore: {
      feedState,
      onUpdateFeedList,
      categoryState: { selectedId },
    },
    detailStore: { onCopyDetailState },
  } = useStore();

  const onGetProjects = () => onUpdateFeedList(apiHeaderState);

  const onClickItem = (id: string) => {
    setSelectType("feed");
    onCopyDetailState({
      ...feedState,
      categoryId: selectedId,
      searchType: "projects",
    });
    history.push(`/detail/${id}`);
  };

  return (
    <IrregularList
      nullList={null}
      list={feedState.list}
      languageCode={languageCode}
      onGetProjects={onGetProjects}
      onClickItem={onClickItem}
      isLoading={feedState.isLoadingList}
    />
  );
};

export default observer(FeedsList);
